import React from 'react'
import withParams from '../../../modules/router-manage/withParams'

import Navbar from '../../templates/navbar/Navbar'
import PortalExportContainer from '../../templates/portal-export/PortalExportContainer'
import PortalHeader from '../../templates/navbar/PortalHeader';

const PortalExportPage = ({ params: { portalID } }) => (
  <div>
    <Navbar portalID={portalID} />
    <div className="container">
      <div className="section">
        <PortalHeader portalID={portalID} />
        <hr />
        <PortalExportContainer portalID={portalID} />
      </div>
    </div>
  </div>
)

export default withParams(PortalExportPage)



// WEBPACK FOOTER //
// ./src/components/pages/web/PortalExportPage.js